import i18n from "intl/i18n"
import { Guid } from "@/types"
import Address, { IAddressDto } from "./Address"
import Location, { ILocationDto } from "./Location"

export enum RequestLocationType {
    eventLocation = "eventLocation",
    userDefined = "userDefined",
    warehouse = "warehouse"
}

export interface IGetRequestLocationDto {
    id: Guid
    type: RequestLocationType
    description: string
    coordinates: ILocationDto
    address: IAddressDto
    warehouseId?: Guid | null
}

export interface ICreateRequestLocation {
    description: string
    coordinates: Location
    address: Address
    warehouseId?: Guid
}

export interface ICreateRequestLocationDto {
    description: string
    coordinates: Location
    address: Address
}

export default class RequestLocation {
    id: Guid
    type: RequestLocationType
    #description: string
    coordinates: Location
    address: Address
    warehouseId?: Guid

    constructor(dto: IGetRequestLocationDto) {
        this.id = dto.id
        this.type = dto.type
        this.#description = dto.description
        this.coordinates = new Location(dto.coordinates)
        this.address = new Address(dto.address)
        this.warehouseId = dto.warehouseId || undefined
    }

    static toCreateDto(data: ICreateRequestLocation) {
        return {
            description: data.description,
            coordinates: data.coordinates.toDto(),
            address: data.address.toDto(),
        }
    }

    get description() {
        return this.type === RequestLocationType.eventLocation
            ? i18n.t("shippingOrders.eventLocation") : this.#description
    }
}
